import { Button } from "@mui/material";
import { styled } from "@mui/material";

const StyleDashboardButtonFilled = styled(Button)`
  background-color: var(--button-primary);
  color: #fff;
  text-transform: lowercase;
  border-radius: 5px !important;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 500;
  height: 40px !important;
  width: fit-content;
  &:hover {
    background-color: var(--button-primary-hover);
    cursor: pointer;
  }
`;

const StyledDashboardButtonOutlined = styled(Button)`
  border: 1px solid var(--button-primary);
  color: var(--button-primary);
  border-radius: 5px !important;
  text-transform: lowercase;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 500;
  height: 40px !important;
  width: fit-content;
  &:hover {
    background-color: transparent;
    border: 1px solid var(--button-primary-hover);
    cursor: pointer;
  }
`;

export const DashboardButtonFilled = ({ children, variant, ...props }) => {
  return (
    <StyleDashboardButtonFilled {...props}>
      {children}
    </StyleDashboardButtonFilled>
  );
};

export const DashboardButtonOutlined = ({ children, variant, ...props }) => {
  return (
    <StyledDashboardButtonOutlined {...props}>
      {children}
    </StyledDashboardButtonOutlined>
  );
};

const DashboardStyledButton = styled(Button)(({ type, maxWidth }) => ({
  backgroundColor: type === "filled" ? "var(--button-primary)" : "transparent",
  color: type === "filled" ? "#fff" : "var(--button-primary)",
  borderRadius: "5px !important",
  padding: "8px 16px",
  fontSize: "16px",
  fontWeight: "500",
  height: "40px !important",
  width: "fit-content",
  border: type === "filled" ? "none" : "1px solid var(--button-primary)",
  maxWidth: maxWidth,
  "&:hover": {
    backgroundColor:
      type === "filled" ? "var(--button-primary-hover)" : "transparent",
    cursor: "pointer",
  },
  textTransform: "unset",
}));

export function DashboardButton({ children, type, maxWidth, ...props }) {
  return (
    <DashboardStyledButton type={type} maxWidth={maxWidth} {...props}>
      {children}
    </DashboardStyledButton>
  );
}
